<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subjects Referred To Clinic
      </h2>
      <p class="tw-italic tw-text-gray-700">

      </p>
    </b-container>

    <b-container>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>
    </b-row>
    </b-container>
    <b-table striped hover :fields="fields" :items="subjects" :filter="filter">
      
    </b-table>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "subject_id" },
        { key: "village" },
        { key: "followup_date", sortable: true, label: "Referred Followup Date" },
        { key: "ae_sae", label: "AE/SAE" },
        { key: "status", sortable: true, label: "Clinic Followup Status" }
      ],
      subjects: [],
      componentKey: 0,
      filter: null,
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/subjects_referred/get_dismissed_list").then(response => {
      that.subjects = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectsreferred', 
            ['getSubjectsReferredCount', 'setSubjectsReferredCount']),

    refreshSideNavCount(){
      this.getSubjectsReferredCount().then((response) => {
                this.setSubjectsReferredCount(response.data);
            })
    },
    dismiss: function(index){
      let that = this;
      HTTP.post("/kenya/subjects_referred/"+that.subjects[index].id+"/", {
        status: 'dismiss'
      }).then(() => {
          that.subjects.splice(index, 1);
          that.refreshSideNavCount();
      });


    }
  }
};
</script>

<style>
</style>